module.exports = __webpack_public_path__ + "img/dept.692be35d.png";